var map = {
	"./Group.png": 81158,
	"./aboutus-icon1.svg": 53001,
	"./add-circle.png": 25522,
	"./angry.svg": 71975,
	"./anguish.svg": 56923,
	"./atom-bond2.svg": 48633,
	"./ban-img-icon-4.svg": 68748,
	"./ban-img-icon5.svg": 64877,
	"./ban-img-icon6.svg": 84381,
	"./ban-six-icon1.svg": 48541,
	"./ban-six-icon2.svg": 46237,
	"./ban-six-icon3.svg": 63459,
	"./bath-tub.svg": 42694,
	"./bottel.svg": 85674,
	"./browse-01.jpg": 50156,
	"./browse-02.jpg": 36901,
	"./browse-03.jpg": 58668,
	"./browse-04.jpg": 10884,
	"./browse-05.jpg": 51365,
	"./camera.svg": 72952,
	"./cardiology.png": 67686,
	"./ch.svg": 6374,
	"./check.svg": 73028,
	"./choose-01.svg": 87583,
	"./choose-02.svg": 80604,
	"./choose-03.svg": 89169,
	"./choose-04.svg": 44502,
	"./choose-icon1.svg": 62767,
	"./choose-icon2.svg": 20445,
	"./choose-icon3.svg": 55885,
	"./choose-icon4.svg": 14566,
	"./clinic-01.png": 67537,
	"./clinic-02.png": 46314,
	"./clinic-03.png": 77653,
	"./clinic-04.png": 29946,
	"./clinic-05.png": 70555,
	"./clinic-06.png": 39619,
	"./clinic-07.png": 91227,
	"./clinic-08.png": 41523,
	"./clinic-09.png": 95910,
	"./clinic-10.png": 47326,
	"./clinic-11.png": 31294,
	"./clinic-12.png": 1846,
	"./clinic-13.png": 4147,
	"./clinic-hover-01.png": 24927,
	"./clinic-hover-02.png": 42679,
	"./clinic-hover-03.png": 58481,
	"./clinic-hover-04.png": 20603,
	"./clinic-hover-05.png": 68918,
	"./clinic-hover-06.png": 26971,
	"./clinic-hover-07.png": 94466,
	"./clinic-hover-08.png": 88547,
	"./clinic-hover-09.png": 60317,
	"./clinic-hover-10.png": 77582,
	"./contact-icon1.svg": 74824,
	"./count-01.svg": 49808,
	"./count-02.svg": 58937,
	"./count-03.svg": 29408,
	"./count-04.svg": 5648,
	"./customer-service-1.svg": 73034,
	"./customer-service-2.svg": 91748,
	"./device-message.svg": 76348,
	"./discover-1.svg": 11552,
	"./discover-2.svg": 72422,
	"./discover-3.svg": 10996,
	"./discover-4.svg": 42867,
	"./discover-5.svg": 38961,
	"./doc-01.svg": 7394,
	"./doc-02.svg": 56610,
	"./doc-03.svg": 526,
	"./doct-01.png": 80744,
	"./doct-02.png": 93987,
	"./doctor-icon.svg": 82142,
	"./down-arrow-gray-dark.svg": 74980,
	"./down-arrow-gray.svg": 89914,
	"./drugs-svg.svg": 44525,
	"./edit.svg": 62365,
	"./email-icon.svg": 45107,
	"./email.svg": 91802,
	"./experience-1.svg": 82514,
	"./experience-2.svg": 99047,
	"./experience-3.svg": 79208,
	"./experience-4.svg": 31587,
	"./experience-5.svg": 76401,
	"./experience-6.svg": 85193,
	"./eye-bg.png": 32883,
	"./eye-icon-01.svg": 99696,
	"./eye-icon.svg": 80475,
	"./eye-white-icon.svg": 84554,
	"./facts-1.svg": 65531,
	"./facts-2.svg": 28039,
	"./facts-3.svg": 50109,
	"./facts-4.svg": 671,
	"./facts-5.svg": 25491,
	"./female.png": 1146,
	"./fifteen-play.svg": 67267,
	"./file.png": 98940,
	"./fluent-password.svg": 69744,
	"./globe.svg": 11909,
	"./google-icon.svg": 17012,
	"./header-icon.svg": 8525,
	"./health-care-1.svg": 74911,
	"./health-care-love.svg": 32835,
	"./healthcare.svg": 58371,
	"./heart-2.svg": 66158,
	"./heart-pulse-fill.svg": 16437,
	"./hex-shape.png": 29410,
	"./hreat-pulse.svg": 50077,
	"./injection.svg": 55479,
	"./lock.svg": 26662,
	"./male.png": 66073,
	"./mic-black.svg": 77478,
	"./mobile-icon.svg": 13895,
	"./mobile.svg": 49298,
	"./password-duotone.svg": 70153,
	"./patient-icon.svg": 74089,
	"./payment-card.png": 85554,
	"./pet-doctor.svg": 15647,
	"./phone-icon.svg": 31248,
	"./phone.png": 53375,
	"./price-icon1.svg": 46402,
	"./price-icon2.svg": 26841,
	"./price-icon3.svg": 64596,
	"./rainbow-1.png": 66377,
	"./rainbow-3.svg": 27230,
	"./rainbow-4.svg": 92617,
	"./search-icon.svg": 28356,
	"./serv-img-icon-1.svg": 24928,
	"./serv-img-icon-2.svg": 5790,
	"./serv-img-icon-3.svg": 14707,
	"./set-cat-01.png": 37405,
	"./set-cat-02.png": 6991,
	"./set-cat-03.png": 20772,
	"./signup-unlock.svg": 20787,
	"./signup-users.svg": 78895,
	"./smart-phone.svg": 51298,
	"./smile.svg": 52174,
	"./smiling-icon.svg": 21007,
	"./star.svg": 55548,
	"./success-tick.svg": 99584,
	"./syringe-svg.svg": 30382,
	"./test-line.svg": 72893,
	"./tick-icon.svg": 40235,
	"./today-icon.svg": 65113,
	"./up-cam.png": 81584,
	"./up-img-1.svg": 71181,
	"./user-doctor.svg": 44854,
	"./video-icon.svg": 43534,
	"./visit-01.png": 461,
	"./visit-02.png": 94666,
	"./visit-03.png": 85518,
	"./we-are-icon1.svg": 45477,
	"./we-are-icon2.svg": 97596,
	"./we-are-icon3.svg": 99624,
	"./work-01.svg": 10517,
	"./work-02.svg": 99791,
	"./work-03.svg": 35954,
	"./work-04.svg": 77121,
	"./x-icon-01.png": 82799,
	"./x-icon.svg": 16374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41199;